import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../firebase';
import { collection, getDocs, doc, setDoc, deleteDoc } from 'firebase/firestore';

const AdminDashboard = () => {
  const { currentUser, updateUserRole } = useAuth();
  const [users, setUsers] = useState([]);
  const [newEmail, setNewEmail] = useState('');
  const [newRole, setNewRole] = useState('student');

  const fetchUsers = async () => {
    const usersCollectionRef = collection(db, 'users');
    const data = await getDocs(usersCollectionRef);
    setUsers(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleRoleChange = async (uid, newRole) => {
    try {
      await updateUserRole(uid, newRole);
      fetchUsers();
    } catch (error) {
      console.error("Failed to update role: ", error);
      alert("Failed to update role: " + error.message);
    }
  };

  const handleAddUser = async (e) => {
    e.preventDefault();
    alert("User creation from client-side is not directly supported for security reasons. Please use Firebase Admin SDK or Firebase Console.");
  };

  const handleDeleteUser = async (uid) => {
    if (window.confirm("Are you sure you want to delete this user? This action cannot be undone.")) {
        alert("User deletion from client-side is not directly supported for security reasons. Please use Firebase Admin SDK or Firebase Console to delete users from Firebase Authentication and then remove their Firestore document.");
    }
  };

  return (
    <div className="min-h-screen bg-bg text-text p-6">
      <h1 className="text-3xl font-bold mb-8 text-primary">Admin Dashboard</h1>
      <div className="mb-8 flex flex-row gap-4 items-center justify-center">
        <a
          href="/nremt-dashboard"
          className="inline-block bg-red-600 text-white font-semibold px-6 py-4 rounded shadow hover:bg-red-800 transition-all duration-200 text-center group"
        >
          <div className="text-3xl mb-2 drop-shadow-lg group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
            🏥
          </div>
          <div>NREMT Assessment Builder 2.0</div>
        </a>
        <a
          href="/skill-sheet-builder"
          className="inline-block bg-primary text-white font-semibold px-6 py-4 rounded shadow hover:bg-secondary hover:text-primary transition-all duration-200 text-center group"
        >
          <div className="text-3xl mb-2 drop-shadow-lg group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
            📋
          </div>
          <div>Skill Sheet Builder</div>
        </a>
        <a
          href="/scenario-builder"
          className="inline-block bg-purple-500 text-white font-semibold px-6 py-4 rounded shadow hover:bg-purple-700 transition-all duration-200 text-center group"
        >
          <div className="text-3xl mb-2 drop-shadow-lg group-hover:scale-110 group-hover:-rotate-3 transition-all duration-300">
            🎭
          </div>
          <div>Scenario Builder</div>
        </a>
        <a
          href="/user-management"
          className="inline-block bg-secondary text-primary font-semibold px-6 py-4 rounded shadow hover:bg-primary hover:text-white transition-all duration-200 text-center group"
        >
          <div className="text-3xl mb-2 drop-shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
            👥
          </div>
          <div>User Management</div>
        </a>
        <a
          href="/classroom-management"
          className="inline-block bg-green-500 text-white font-semibold px-6 py-4 rounded shadow hover:bg-green-700 transition-all duration-200 text-center group"
        >
          <div className="text-3xl mb-2 drop-shadow-lg group-hover:scale-110 group-hover:-rotate-6 transition-all duration-300">
            🏫
          </div>
          <div>Classroom Management</div>
        </a>
        <a
          href="/lab-assignments"
          className="inline-block bg-blue-500 text-white font-semibold px-6 py-4 rounded shadow hover:bg-blue-700 transition-all duration-200 text-center group"
        >
          <div className="text-3xl mb-2 drop-shadow-lg group-hover:scale-110 group-hover:rotate-12 transition-all duration-300">
            🧪
          </div>
          <div>Lab Assignments</div>
        </a>
        <a
          href="/batch-tool"
          className="inline-block bg-orange-500 text-white font-semibold px-6 py-4 rounded shadow hover:bg-orange-700 transition-all duration-200 text-center group"
        >
          <div className="text-3xl mb-2 drop-shadow-lg group-hover:scale-110 group-hover:-rotate-12 transition-all duration-300">
            📜
          </div>
          <div>Batch Certificate Tool</div>
        </a>
      </div>
    </div>
  );
};

export default AdminDashboard;
